import React from "react";

// Clickable account number with a Prepaid/Postpaid badge. Falls back to plain
// text for accounts that are not power/water customer accounts (lease, levy...).
const AccountNumberCell = ({ accountNumber, getAccount, openAccount }) => {
  if (!accountNumber) return <span className="text-muted">-</span>;

  const account = getAccount(accountNumber);
  // Levy accounts are looked up only for their unit; they have no account page
  if (!account || !account.type) return <span>{accountNumber}</span>;

  const isPostpaid = account.type === "Postpaid";
  return (
    <span className="d-inline-flex align-items-center gap-2">
      <button
        type="button"
        className="btn btn-link p-0 text-decoration-underline"
        style={{ fontSize: "inherit" }}
        title={`Open ${account.type.toLowerCase()} ${account.utility} account`}
        onClick={() => openAccount(accountNumber)}
      >
        {accountNumber}
      </button>
      <span
        className={`badge ${isPostpaid ? "bg-warning text-dark" : "bg-success"}`}
      >
        {account.type}
      </span>
    </span>
  );
};

export default AccountNumberCell;
